import { ROUTE_RISK_SCORE_REVEAL } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './risk-score-reveal.page';

export const routeRiskScoreReveal: RouteObject = {
  path: ROUTE_RISK_SCORE_REVEAL,
  Component: Page,
  loader: setTitleFromLoader('Risk Score Reveal'),
};